import { render, staticRenderFns } from "./PrePostLimitCreditHistory.vue?vue&type=template&id=11350aa8"
import script from "./PrePostLimitCreditHistory.vue?vue&type=script&lang=js"
export * from "./PrePostLimitCreditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports